jQuery(document).ready(function(){
  jQuery(window).on("scroll", function () {
    if( jQuery("body").hasClass("product-page") ) {
      if( jQuery(window).scrollTop() > 700 ) {
        jQuery("#shopify-section-template--23023317188921__rich_text_XDzL87").show();
      } else {
        jQuery("#shopify-section-template--23023317188921__rich_text_XDzL87").hide();
      }
    }
  });
});

jQuery(window).on("load", function(){
  function formatReview(x) {
    x = x.toString();
    var lastThree = x.substring(x.length - 3);
    var otherNumbers = x.substring(0, x.length - 3);
    if (otherNumbers !== '')
        lastThree = ',' + lastThree;
    var result = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;
    result = result.replace(/,+/g,',');
    return result;
  }
  
  jQuery(document).find(".review-number .link").each(function(){
    jQuery(this).text(formatReview(jQuery(this).text()));
  });

  jQuery(document).find(".review-summary > span a u").each(function(){
    jQuery(this).text(formatReview(jQuery(this).text()));
  });

  jQuery(document).find(".prose p a u").each(function(){
    jQuery(this).text(formatReview(jQuery(this).text()));
  });
});